(function(){
  // Shared by BL Shop Grid (.pgrid) and BL How It Works (.mech-flow): adds
  // left/right scroll arrows on narrow viewports where the row scrolls horizontally.
  var sel = '.pgrid, .mech-flow';
  function amt(track){ var c=track.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : track.clientWidth*0.85; }
  document.querySelectorAll(sel).forEach(function(track){
    if(track.dataset.hscroll) return; track.dataset.hscroll='1';
    var wrap=document.createElement('div'); wrap.className='hscroll';
    track.parentNode.insertBefore(wrap, track);
    var prev=document.createElement('button'); prev.type='button'; prev.className='hscroll-btn prev'; prev.setAttribute('aria-label','Scroll left'); prev.innerHTML='&larr;';
    var next=document.createElement('button'); next.type='button'; next.className='hscroll-btn next'; next.setAttribute('aria-label','Scroll right'); next.innerHTML='&#10132;';
    wrap.appendChild(prev); wrap.appendChild(track); wrap.appendChild(next);
    prev.addEventListener('click',function(){ track.scrollBy({left:-amt(track),behavior:'smooth'}); });
    next.addEventListener('click',function(){ track.scrollBy({left:amt(track),behavior:'smooth'}); });
    function upd(){ var s=(track.scrollWidth-track.clientWidth)>4; wrap.classList.toggle('has-scroll',s); prev.disabled=track.scrollLeft<=2; next.disabled=track.scrollLeft>=(track.scrollWidth-track.clientWidth-2); }
    track.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd);
    upd(); setTimeout(upd,300);
  });
})();
